<template lang="pug">
  div
    slot(name='children'
        v-bind:genericParentContainer='innerContainer',
        v-bind:parentContainer='outerContainer')
    //slot(name="child",
        v-bind:parentContainer='container')
      //p am sprite {{transform.id}}

    slot(name='holder',
        v-bind:holder='holder',
        v-bind:transform='transform',
        v-bind:depth='depth',
        v-bind:context='context',
        v-bind:innerContainer='innerContainer',
        v-bind:outerContainer='outerContainer',
        v-bind:displayObject='innerContainer')

</template>
<script>
export default {
  props:{
    transform: {
      type: Object,
      required: true
    },
    innerContainer: {
      type: Object,
      required: true
    },
    outerContainer: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    holder: {
      type: Object,
      required: true
    },
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  components:{
  },
  mounted() {
    this.$emit('loaded');
  },
  methods:{
  },
  beforeDestroy() {
  },
  computed:{
  },
  watch:{
  }
}
</script>

